module.exports = __webpack_public_path__ + "static/media/light-home.ef6c4819.png";